// extracted by mini-css-extract-plugin
export var childrenContainer = "_2x-0";